import { To, useNavigate, useOutletContext, useParams } from 'react-router-dom'

import { useAsyncData } from 'modules/core/hooks/useAsyncData'

import contractVersions from 'modules/contracts/store/collections/contractVersions'
import DocumentModal from 'modules/documents/components/DocumentModal'
import { Document } from 'modules/documents/hooks/documents/useGetDocuments'

const DocumentViewerPage = () => {
  const navigate = useNavigate()
  const { document_id: documentId } = useParams()
  const { documentsEntity, parentRoute } = useOutletContext<{
    documentsEntity: Document[]
    parentRoute: To
  }>()

  const { loading } = useAsyncData(
    () => contractVersions.fetch({ withCachedFetchParams: true }),
    []
  )

  const onClose = () => {
    navigate(parentRoute)
  }

  if (!documentId) {
    return null
  }

  return (
    <DocumentModal
      documentId={documentId}
      documents={documentsEntity}
      onClose={onClose}
      contractVersions={contractVersions}
      loading={loading}
    />
  )
}

export default DocumentViewerPage
